export const TAB_ID_SESSIONSTORAGE_KEY = "MULTI_SESSION_TAB_ID";
export const TAB_COMMUNICATION_CHANNEL =
  "MULTI_SESSION_TAB_COMMUNICATION_CHANNEL";
export const TAB_EMIT_TIMESTAMP_SESSIONSTORAGE_KEY =
  "MULTI_SESSION_TAB_EMIT_TIMESTAMP";

// When present and "true" in the URL query, the app boots WITHOUT multi-tab
// detection — used for read-only attachment-preview tabs opened from within the
// interview, so they don't count as a second interview tab. Security note: this
// is a deliberate, narrow bypass; only the attachment-open flow appends it.
export const ATTACHMENT_PREVIEW_PARAM = "attachmentPreview";

export const TAB_ERROR_PAGE = {
  title: "Multiple Tabs Detected!",
  description:
    "It seems like you have opened multiple tabs of the interview in the same browser. \n \n Thank you!",
};
